import type { CSSProperties, ReactNode } from 'react';
import { Button } from '@/components/Form';

/**
 * 표 바로 왼쪽 위의 [+ 새 줄] · 건수 — 누르면 [시트에 추가] · [취소] · 안내가 된다
 * (2026-10-23 오너 "새 줄 버튼을 시트에 추가 버튼 위치에다가 놓자" → "+새 줄 버튼은 표 왼쪽 위에 보이게"
 * → "이건 + 새 줄 버튼 오른쪽에 나오게 … 새 줄 버튼을 누르면 지금 위치로 올라가게 … 끝나면 다시 돌아오고").
 * 작성 중 모습을 어디에 둘지(검색 칸 자리)는 화면이 정한다. 데모-계약 전환 · 도입 문의 현황이 같이 쓴다.
 */
export function SheetNewRowBar({
  drafting,
  canAdd,
  adding,
  hint,
  count,
  onStart,
  onCancel,
  onAdd,
}: {
  /** 새 줄 작성 중 */
  drafting: boolean;
  /** 꼭 넣을 칸이 찼다 */
  canAdd: boolean;
  /** 서버로 보내는 중 */
  adding: boolean;
  /** 작성 중 안내 */
  hint: ReactNode;
  /** [+ 새 줄] 오른쪽의 건수('200건') */
  count?: ReactNode;
  onStart: () => void;
  onCancel: () => void;
  onAdd: () => void;
}) {
  if (!drafting)
    return (
      <div style={bar}>
        <Button type="button" onClick={onStart} data-testid="sheet-add-row">
          + 새 줄
        </Button>
        {count}
      </div>
    );
  return (
    <div style={bar} data-testid="sheet-draft-bar">
      <Button
        type="button"
        disabled={adding || !canAdd}
        onClick={onAdd}
        data-testid="sheet-draft-add"
      >
        시트에 추가
      </Button>
      <Button variant="secondary" type="button" onClick={onCancel}>
        취소
      </Button>
      <span className="kuun-caption" style={{ color: 'var(--fg-muted)' }}>
        {hint}
      </span>
    </div>
  );
}

const bar: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 8,
};
